// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"367":"93d646dd","455":"dbe643ee","977":"ca9f9da5"}[chunkId] + ".chunk.js";
};